import { defineMessages } from 'react-intl-next';

export const messages: {
	progressCirclesNavigationStyleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	thumbnailsNavigationStyleLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	progressCirclesNavigationStyleLabel: {
		id: 'company-hub.carousel-extension.config-panel.navigation.progress-circles',
		defaultMessage: 'Progress circles',
		description: 'Text label for the progress circles navigation style option',
	},
	thumbnailsNavigationStyleLabel: {
		id: 'company-hub.carousel-extension.config-panel.navigation.thumbnails',
		defaultMessage: 'Thumbnails',
		description: 'Text label for the thumbnails navigation style option',
	},
});
